module.exports = __webpack_public_path__ + "static/media/Domingo Benito Calderón.b9ff630f.jpg";